<template>
  <transition name="dialog-fade" appear>
    <div class="dialog-mask" @click="onMaskClick">
      <div class="dialog-panel" @click.stop>
        <slot />
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: 'BaseDialog',
  props: {
    closeOnMask: {
      type: Boolean,
      default: false,
    }
  },
  methods: {
    onMaskClick() {
      if (!this.closeOnMask) return
      this.$emit('reject', false)
    }
  }
}
</script>

<style scoped>
.dialog-mask {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.8);
  z-index: 300;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 16px;
  box-sizing: border-box;
}

.dialog-panel {
  box-shadow: 0 12px 40px rgba(0, 0, 0, 0.24);
  /* overflow: hidden; */
  transform-origin: 50% 50%;
}

.dialog-fade-enter-active,
.dialog-fade-leave-active {
  transition: opacity 0.24s ease;
}

.dialog-fade-enter-active .dialog-panel,
.dialog-fade-appear-active .dialog-panel {
  animation: dialog-panel-in 0.24s ease both;
}

.dialog-fade-leave-active .dialog-panel {
  animation: dialog-panel-out 0.2s ease both;
}

.dialog-fade-enter,
.dialog-fade-appear,
.dialog-fade-leave-to {
  opacity: 0;
}

@keyframes dialog-panel-in {
  0% {
    opacity: 0;
    transform: scale(0.88);
  }

  100% {
    opacity: 1;
    transform: scale(1);
  }
}

@keyframes dialog-panel-out {
  0% {
    opacity: 1;
    transform: scale(1);
  }

  100% {
    opacity: 0;
    transform: scale(0.92);
  }
}
</style>
